import { Button } from "@devhop/ui";
import { HelpCircleIcon, PlusIcon } from "lucide-react";

type RatesToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
  onStartTour?: () => void;
};

export function RatesToolbar({
  canManage,
  onCreate,
  onStartTour,
}: RatesToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="flex items-center font-bold text-2xl tracking-tight">
            ອັດຕາຄ່າສົ່ງ{" "}
            {onStartTour && (
              <Button
                variant="ghost"
                size="icon"
                onClick={onStartTour}
                className="ml-2 size-6"
                title="ເລີ່ມທົດລອງການນຳທາງ"
              >
                <HelpCircleIcon className="h-4 w-4" />
              </Button>
            )}
          </h2>
          <p className="text-muted-foreground">
            ລາຍການອັດຕາຄ່າສົ່ງຕາມໂຊນ ແລະ ນ້ຳໜັກ (ກຣາມ).
          </p>
        </div>
        <div
          className="flex items-center gap-2"
          data-tourid="shipping-rates-toolbar"
        >
          {canManage && (
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງອັດຕາຄ່າສົ່ງ
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
